import { render, staticRenderFns } from "./specificCompanyLogin.vue?vue&type=template&id=13dc973c"
import script from "./specificCompanyLogin.vue?vue&type=script&lang=js"
export * from "./specificCompanyLogin.vue?vue&type=script&lang=js"
import style0 from "./specificCompanyLogin.vue?vue&type=style&index=0&id=13dc973c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports